/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContrattoResDto } from '../../models/contratto-res-dto';
import { PaginatedDocumented } from '../../models/paginated-documented';

export interface ContrattiControllerFindManyContratti$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 20
   *
   *
   *
   * **Max Value:** 0
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by id query param.
   *
   * **Format:** filter.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.id=$eq:John Doe&filter.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.id'?: Array<string>;

  /**
   * Filter by organizzazione.id query param.
   *
   * **Format:** filter.organizzazione.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.organizzazione.id=$eq:John Doe&filter.organizzazione.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.organizzazione.id'?: Array<string>;

  /**
   * Filter by organizzazione.denominazione query param.
   *
   * **Format:** filter.organizzazione.denominazione={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.organizzazione.denominazione=$btw:John Doe&filter.organizzazione.denominazione=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.organizzazione.denominazione'?: Array<string>;

  /**
   * Filter by persona.id query param.
   *
   * **Format:** filter.persona.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.persona.id=$eq:John Doe&filter.persona.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.persona.id'?: Array<string>;

  /**
   * Filter by persona.nome query param.
   *
   * **Format:** filter.persona.nome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.persona.nome=$btw:John Doe&filter.persona.nome=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.persona.nome'?: Array<string>;

  /**
   * Filter by persona.cognome query param.
   *
   * **Format:** filter.persona.cognome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.persona.cognome=$btw:John Doe&filter.persona.cognome=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.persona.cognome'?: Array<string>;

  /**
   * Filter by tipo.id query param.
   *
   * **Format:** filter.tipo.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.tipo.id=$eq:John Doe&filter.tipo.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.tipo.id'?: Array<string>;

  /**
   * Filter by tipo.nome query param.
   *
   * **Format:** filter.tipo.nome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.tipo.nome=$btw:John Doe&filter.tipo.nome=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.tipo.nome'?: Array<string>;

  /**
   * Filter by dal query param.
   *
   * **Format:** filter.dal={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.dal=$eq:John Doe&filter.dal=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.dal'?: Array<string>;

  /**
   * Filter by al query param.
   *
   * **Format:** filter.al={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.al=$eq:John Doe&filter.al=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.al'?: Array<string>;

  /**
   * Filter by oreSettimanali query param.
   *
   * **Format:** filter.oreSettimanali={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.oreSettimanali=$eq:John Doe&filter.oreSettimanali=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.oreSettimanali'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=id:DESC&sortBy=organizzazione.id:DESC
   *
   *
   * **Default Value:** persona.cognome:ASC
   *
   * **Available Fields**
   * - id
   *
   * - organizzazione.id
   *
   * - organizzazione.denominazione
   *
   * - persona.id
   *
   * - persona.nome
   *
   * - persona.cognome
   *
   * - tipo.id
   *
   * - tipo.nome
   *
   * - oreSettimanali
   *
   * - dal
   *
   * - al
   */
  sortBy?: Array<
    | 'id:ASC'
    | 'id:DESC'
    | 'organizzazione.id:ASC'
    | 'organizzazione.id:DESC'
    | 'organizzazione.denominazione:ASC'
    | 'organizzazione.denominazione:DESC'
    | 'persona.id:ASC'
    | 'persona.id:DESC'
    | 'persona.nome:ASC'
    | 'persona.nome:DESC'
    | 'persona.cognome:ASC'
    | 'persona.cognome:DESC'
    | 'tipo.id:ASC'
    | 'tipo.id:DESC'
    | 'tipo.nome:ASC'
    | 'tipo.nome:DESC'
    | 'oreSettimanali:ASC'
    | 'oreSettimanali:DESC'
    | 'dal:ASC'
    | 'dal:DESC'
    | 'al:ASC'
    | 'al:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** id,organizzazione.id,organizzazione.denominazione,persona.id,persona.nome
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - id
   *
   * - organizzazione.id
   *
   * - organizzazione.denominazione
   *
   * - persona.id
   *
   * - persona.nome
   *
   * - persona.cognome
   *
   * - tipo.id
   *
   * - tipo.nome
   *
   * - oreSettimanali
   *
   * - dal
   *
   * - al
   */
  searchBy?: Array<string>;
}

export function contrattiControllerFindManyContratti(
  http: HttpClient,
  rootUrl: string,
  params?: ContrattiControllerFindManyContratti$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<ContrattoResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          id?: string | Array<string>;
          'organizzazione.id'?: string | Array<string>;
          'organizzazione.denominazione'?: string | Array<string>;
          'persona.id'?: string | Array<string>;
          'persona.nome'?: string | Array<string>;
          'persona.cognome'?: string | Array<string>;
          'tipo.id'?: string | Array<string>;
          'tipo.nome'?: string | Array<string>;
          dal?: string | Array<string>;
          al?: string | Array<string>;
          oreSettimanali?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    contrattiControllerFindManyContratti.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.id', params['filter.id'], {});
    rb.query(
      'filter.organizzazione.id',
      params['filter.organizzazione.id'],
      {},
    );
    rb.query(
      'filter.organizzazione.denominazione',
      params['filter.organizzazione.denominazione'],
      {},
    );
    rb.query('filter.persona.id', params['filter.persona.id'], {});
    rb.query('filter.persona.nome', params['filter.persona.nome'], {});
    rb.query('filter.persona.cognome', params['filter.persona.cognome'], {});
    rb.query('filter.tipo.id', params['filter.tipo.id'], {});
    rb.query('filter.tipo.nome', params['filter.tipo.nome'], {});
    rb.query('filter.dal', params['filter.dal'], {});
    rb.query('filter.al', params['filter.al'], {});
    rb.query('filter.oreSettimanali', params['filter.oreSettimanali'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<ContrattoResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                id?: string | Array<string>;
                'organizzazione.id'?: string | Array<string>;
                'organizzazione.denominazione'?: string | Array<string>;
                'persona.id'?: string | Array<string>;
                'persona.nome'?: string | Array<string>;
                'persona.cognome'?: string | Array<string>;
                'tipo.id'?: string | Array<string>;
                'tipo.nome'?: string | Array<string>;
                dal?: string | Array<string>;
                al?: string | Array<string>;
                oreSettimanali?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

contrattiControllerFindManyContratti.PATH = '/admin/contratti';
